import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useStyles } from "./styles";

export function SocialNetwork() {
  const styles = useStyles();

  return (
    <Stack spacing={2}>
      <div className={styles.root}>
        <Typography variant="h6">Redes sociais</Typography>
        <Typography variant="body2">Subtitulo</Typography>
      </div>
    </Stack>
  );
}
